import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { SAVE_CHANGES_LABEL, UPDATE_SUCCESS, USER_ROLE } from '@microsec/constants';
import { BaseComponent } from '@ids-components';
import { FormBuilderComponent } from '@microsec/components';
import { FormItem } from '@microsec/models';
import { ThreatService } from '@ids-services';

import { finalize } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

export const FORM_PARAMS = {
  COMMENT: 'comment',
};

@Component({
  selector: 'app-threat-comment',
  templateUrl: './threat-comment.component.html',
  styleUrls: ['./threat-comment.component.scss'],
  imports: [CommonModule, ButtonModule, TooltipModule, FormBuilderComponent],
})
export class ThreatCommentComponent extends BaseComponent implements AfterViewInit {
  isLoading = false;

  fields: FormItem[] = [];

  @ViewChild('fb') form!: FormBuilderComponent;

  SAVE_CHANGES_LABEL = SAVE_CHANGES_LABEL;

  FORM_PARAMS = FORM_PARAMS;

  _threat = false;

  get threat() {
    return this._threat;
  }

  @Input() set threat(value: any) {
    this._threat = value;
    if (!!this._threat) {
      this.initForm();
      this.form?.patchValue(this._threat);
    }
  }

  constructor(private threatSrv: ThreatService) {
    super();
  }

  async ngAfterViewInit() {
    await this.prepareConfigs();
    this.initForm();
  }

  initForm() {
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.COMMENT,
        hasNoLabel: true,
        field: 'textarea',
        defaultValue: this.threat?.comment || '',
        disabled: !!this.threat.is_imported || !this.permissions[USER_ROLE.TECHNICIAN],
        maxInputLimit: null,
      } as FormItem),
    ];
    fields.forEach((field) => (field.isMediumSize = true));
    this.fields = fields;
  }

  onSubmit() {
    this.form.isLoading = true;
    const payload = { ...this.form.getRawValue() };
    this.threatSrv
      .updateThreat(this.threat.threat_id, payload)
      .pipe(
        finalize(() => {
          this.form.isLoading = false;
        }),
      )
      .subscribe({
        next: () => {
          this.showSuccessMessage(UPDATE_SUCCESS.replace('{0}', 'threat comment'));
          this.threatSrv.refresh$.next(true);
        },
        error: (error) => {
          this.form.showServerErrorMessage(error);
          this.showErrorMessage(error);
        },
      });
  }
}
